<section
    [ngClass]="{ isAnimating: isAnimating }"
    class="sidenav-main-container accent-container {{ shouldBeExpanded ? '' : 'mini' }}"
>
    <!-- Expand / Collapse Button -->
    <div class="expand-collapse-container unselectable">
        <a
            (click)="expandCollapseSidenav()"
            class="expand-collapse-button"
        >
            @if (isExpanded) {
            <mat-icon class="expand-collapse-button-icon">keyboard_arrow_left</mat-icon>
            } @if (!isExpanded) {
            <mat-icon class="expand-collapse-button-icon">keyboard_arrow_right</mat-icon>
            }
        </a>
    </div>
    <div class="sidenav-container">
        <div class="full-height flex-column flex-space-between-stretch">
            <div>
                <app-switcher
                    class="app-switcher"
                    [align]="isExpanded ? 'flex-start' : 'center'"
                    [ngClass]="{ mini: !isExpanded }"
                ></app-switcher>

                <!-- Bitdefender Logo -->
                <div [ngClass]="{ mini: !isExpanded, logo: isExpanded }">
                    @if (isExpanded && (identityService.companyLoaded$ | async) === true) {
                    <img
                        alt="Bitdefender MDR"
                        src="{{ sidenavService.logo }}"
                    />
                    } @if (!isExpanded) {
                    <img
                        alt="Bitdefender MDR"
                        class="logo-mini"
                        src="assets/images/logo/B-icon-Red.svg"
                    />
                    }
                </div>
                <!-- Top Buttons -->
                <div class="sidenav-buttons-container">
                    @for (button of buttons; track button; let i = $index) {
                    <div>
                        @if (button.show) {
                        <ng-container *appEnableForRoles="button.roles">
                            @if (button.id !== 'sidenav-companies-button' || identityService.isCompanySelectorVisible()) {
                            <div class="test-ke">
                                @if (!button.isExpandable && !button.newTab) {
                                <button
                                    id="{{ button.id }}"
                                    class="sidenav-button"
                                    [disabled]="checkIfRouteActive(button.id)"
                                    routerLink="{{ button.link() }}"
                                    routerLinkActive="sidenav-button-active"
                                >
                                    <span class="menu-selector"></span>
                                    <span class="sidenav-button-icon {{ button.icon }}"></span>
                                    <span class="sidenav-button-text text-wrap-auto">
                                        {{ button.text === 'FAQ' ? (button.text | uppercase) : (button.text | titlecase) }}
                                    </span>
                                </button>
                                } @else if (button.isExpandable) {
                                <div
                                    id="{{ button.id + '-expandable' }}"
                                    class="wrap-menu-item"
                                    (mouseover)="calculateSubmenuPosition(button.id + '-expandable', 'floating-menu-' + button.id)"
                                    [ngClass]="{ 'panel-not-expanded': !isExpanded }"
                                >
                                    <mat-expansion-panel
                                        #panel
                                        (closed)="panelIsClosing(button.text)"
                                        (opened)="panelIsOpening(button.text)"
                                        [expanded]="checkPanelExpanded(button.text)"
                                        [disabled]="!isExpanded || isAnimating"
                                    >
                                        <mat-expansion-panel-header
                                            class="expanded-sidenav"
                                            [ngClass]="isExpanded ? 'expansion-sidenav-button' : 'expansion-sidenav-button-small'"
                                            style="padding: 0 !important"
                                        >
                                            <button
                                                class="sidenav-button"
                                                [ngClass]="isExpanded ? 'height-70' : 'height-75'"
                                            >
                                                <span class="menu-selector"></span>
                                                <span class="sidenav-button-icon {{ button.icon }}"></span>
                                                <span class="sidenav-button-text text-wrap-auto">{{ button.text | titlecase }}</span>

                                                @if (button.notifications && sumOfAllNotifications > 0) {

                                                <mat-chip-option
                                                    class="sidenav-notification"
                                                    disabled="true"
                                                    color="primary"
                                                    [ngClass]="isExpanded ? 'm-l-5' : 'm-l-0'"
                                                    >{{ sumOfAllNotifications > 99 ? '99+' : sumOfAllNotifications }}
                                                </mat-chip-option>
                                                }
                                            </button>
                                        </mat-expansion-panel-header>
                                        @for (subButton of button.buttons; track subButton) { @if (subButton.show) {
                                        <button
                                            *appEnableForRoles="subButton.roles"
                                            id="{{ subButton.id }}"
                                            class="sidenav-button"
                                            style="height: 30px !important"
                                            routerLink="{{ subButton.link() }}"
                                            routerLinkActive="sidenav-button-active"
                                        >
                                            <span class="menu-selector"></span>
                                            <span class="sidenav-button-icon {{ subButton.icon }}"></span>
                                            <span class="submenu-button-text">{{ subButton.text | titlecase }}</span>
                                            @if (subButton.notifications && notificationsList.length > 0 &&
                                            getNotificationsValue(subButton.notifications)) {
                                            <mat-chip-option
                                                class="sidenav-notification m-l-5"
                                                disabled="true"
                                                color="primary"
                                                >{{ getNotificationsValueUI(subButton.notifications) }}
                                            </mat-chip-option>
                                            }
                                        </button>
                                        } }
                                    </mat-expansion-panel>
                                    <div
                                        id="{{ 'floating-menu-' + button.id }}"
                                        class="floating-menu"
                                    >
                                        @for (subButton of button.buttons; track subButton) {
                                        <div>
                                            <button
                                                *appEnableForRoles="subButton.roles"
                                                id="{{ subButton.id }}"
                                                routerLink="{{ subButton.link() }}"
                                                routerLinkActive="sidenav-button-active"
                                                class="sidenav-button expansion-submenu-button"
                                            >
                                                <span class="menu-selector"></span>
                                                <span class="submenu-button-text">{{ subButton.text | titlecase }}</span>
                                                @if (subButton.notifications && notificationsList.length > 0 &&
                                                getNotificationsValue(subButton.notifications)) {
                                                <mat-chip-option
                                                    class="sidenav-notification m-l-5"
                                                    disabled="true"
                                                    color="primary"
                                                    >{{ getNotificationsValueUI(subButton.notifications) }}
                                                </mat-chip-option>
                                                }
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                            }
                        </ng-container>
                        }
                    </div>
                    }
                </div>
            </div>
            <!-- Bottom Buttons -->
            @if (authService.jwtUser; as user) {
            <div class="sidenav-buttons-container sidenav-bottom-buttons-container">
                <div>
                    @if (authService.hasRoles([UserPermission.NotificationsSettingsRead])) {
                    <button
                        id="notifications_button"
                        [@highlightNotifications]="isHighlighted ? 'highlight' : 'stop-highlight'"
                        class="sidenav-button"
                        routerLink="/notifications/browse"
                        routerLinkActive="sidenav-button-active"
                    >
                        <span class="menu-selector"></span>
                        <span
                            [ngClass]="{ 'm-l-7': isExpanded && (!isAnimating || shouldBeExpanded) }"
                            class="sidenav-button-icon ds-icon-notification_bell fs-24"
                        ></span>
                        <section class="sidenav-button-text m-l-7 text-wrap-auto">Notification profiles</section>
                    </button>
                    }
                </div>
                <div>
                    <button
                        id="sidenav-profile-button"
                        class="sidenav-button"
                        routerLinkActive="sidenav-button-active"
                    >
                        <span class="menu-selector"></span>
                        <img
                            [ngClass]="{ 'm-l-7': isExpanded && (!isAnimating || shouldBeExpanded) }"
                            class="sidenav-button-icon"
                            src="assets/images/default-avatar.png"
                            alt=""
                        />
                        @if (isExpanded && (!isAnimating || shouldBeExpanded)) {
                        <section
                            class="sidenav-button-text m-l-7"
                            (mouseover)="checkIfUsernameTooltipIsNecessary($event)"
                            [matTooltip]="user.Name | titlecase"
                            [matTooltipDisabled]="isUsernameTooltipDisabled"
                        >
                            {{ user.Name | titlecase }}
                        </section>
                        }
                    </button>
                </div>
                <div>
                    <button
                        id="sidenav-logout-button"
                        class="sidenav-button"
                        (click)="onLogoutClicked()"
                    >
                        <span class="menu-selector"></span>
                        <span class="sidenav-button-icon ds-icon-log-out"></span>
                        @if (isExpanded && (!isAnimating || shouldBeExpanded)) {
                        <span
                            id="sidenav-logout-button-text"
                            class="sidenav-button-text m-l-3"
                        >
                            {{ 'Logout' }}
                        </span>
                        }
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
</section>
